export default "__VITE_ASSET__f43441da__"